export default __webpack_public_path__ + "static/media/pro-elevate-blk-banner-2.a25985a9.jpg";